import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/system'
import { muiTheme } from '@pbt/pbt-ui-components'

import Typography from '~/components/elements/Typography/Typography'

const SystemMessageLabel = ({
  color,
  icon,
  isSelectOption,
  fontSize = 'Paragraph',
}: {
  color?: string
  fontSize?: string
  icon: ReactElement
  isSelectOption?: boolean
}) => {
  const { t } = useTranslation(['Common'])
  const TypographyWrapper = Typography[fontSize]

  return (
    <Stack
      alignItems="center"
      data-testid="system-message-label"
      direction="row"
      spacing={isSelectOption ? 1 : 0.5}
      sx={{ width: 'max-content' }}
    >
      {icon}
      <Stack>
        {isSelectOption && (
          <Typography.ParagraphSm sx={{ color: muiTheme.colors.grayGray2 }}>
            {t('Common:ASSIGNED')}
          </Typography.ParagraphSm>
        )}

        <TypographyWrapper sx={{ color }}>
          {t('Common:SYSTEM')}
        </TypographyWrapper>
      </Stack>
    </Stack>
  )
}

export default SystemMessageLabel
